__turbopack_context__.v({
  "content": "HomeOverflowNav-module-scss-module__FUBPWG__content",
  "home-nav-overflow-in": "HomeOverflowNav-module-scss-module__FUBPWG__home-nav-overflow-in",
  "inlineList": "HomeOverflowNav-module-scss-module__FUBPWG__inlineList",
  "measure": "HomeOverflowNav-module-scss-module__FUBPWG__measure",
  "measureLink": "HomeOverflowNav-module-scss-module__FUBPWG__measureLink",
  "measureList": "HomeOverflowNav-module-scss-module__FUBPWG__measureList",
  "menuIcon": "HomeOverflowNav-module-scss-module__FUBPWG__menuIcon",
  "menuItem": "HomeOverflowNav-module-scss-module__FUBPWG__menuItem",
  "menuList": "HomeOverflowNav-module-scss-module__FUBPWG__menuList",
  "moreChevron": "HomeOverflowNav-module-scss-module__FUBPWG__moreChevron",
  "moreTrigger": "HomeOverflowNav-module-scss-module__FUBPWG__moreTrigger",
  "root": "HomeOverflowNav-module-scss-module__FUBPWG__root",
  "visible": "HomeOverflowNav-module-scss-module__FUBPWG__visible",
});
